import { resolveSiteUrl } from "@shared/site-url";

// Canonical public origin — override via VITE_APP_BASE_URL (mirrored from
// APP_BASE_URL at build time in vite.config.ts when unset). Default is
// verascap.com (only public site of record).
const site = resolveSiteUrl(import.meta.env.VITE_APP_BASE_URL);

export const BRAND = {
  siteName: "Veras Capital",
  siteNameFull: "Veras Capital — EB-5 Investor Visa Advisory",
  shortName: "Veras Capital",
  domain: site.domain,
  domainUrl: site.domainUrl,
  legalEntity: "Veras Capital, LLC",
  parentCompany: "Veras Capital, LLC",
  // Canonical public mailing address (CAN-SPAM / legal notices). Override via
  // VITE_COMPANY_MAILING_ADDRESS (mirrored from COMPANY_MAILING_ADDRESS at
  // build time in vite.config.ts when unset) — same default as the server.
  mailingAddress:
    (import.meta.env.VITE_COMPANY_MAILING_ADDRESS as string | undefined)?.trim() ||
    "Veras Capital, LLC, 1409 S Church Street, Greenville, SC 29605, USA",
  // Public support inbox on the canonical brand domain.
  supportEmail: "hello@verascap.com",
  socialImage: "/og-image.png",
  logoPath: "/logo-dark.svg",

  // WhatsApp click-to-chat number for the site-wide "Chat on WhatsApp"
  // entry points. Digits only, E.164 format (country code + number) with
  // no "+", spaces, or dashes — e.g. "15551234567". Leave this as an
  // empty string ("") to hide every WhatsApp button across the site; it
  // acts as a single on/off switch. This is the Veras WhatsApp Business
  // number: +1 (864) 567-3242.
  whatsappNumber: "18645673242",

  // Org-level social destinations (mirrored from server/brand-config.ts).
  social: {
    linkedin: "https://www.linkedin.com/company/veras-capital",
    facebook: "https://www.facebook.com/verascapital",
    instagram: "https://www.instagram.com/verascapital",
    youtube: "https://www.youtube.com/@verascapital",
    tiktok: "https://www.tiktok.com/@verascapital",
    x: "",
  },

  office: {
    label: "Greenville, SC",
    address: "1409 S Church Street, Greenville, SC 29605",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=1409+S+Church+Street,+Greenville,+SC+29605",
  },

  colors: {
    primary: "#1E3A5F",
    gold: "#C9A84C",
    goldLight: "#D9BD6C",
    goldDark: "#A8893C",
    accent: "#2D7D46",
    dark: "#0F172A",
    navy: "#0A2540",
    navyLight: "#2a2a4a",
    white: "#ffffff",
    background: "#FFFFFF",
    surface: "#F8F9FA",
    textPrimary: "#0A2540",
    textSecondary: "#6B7280",
    error: "#DC2626",
    success: "#16A34A",
    warning: "#F59E0B",
    info: "#3B82F6",
    grayBg: "#f7f7f8",
    grayText: "#6b7280",
    grayBorder: "#e5e7eb",
    bodyText: "#374151",
  },

  goldHsl: "44 54% 54%",

  fonts: {
    heading: "DM Sans",
    body: "DM Sans",
    serif: "Georgia",
    mono: "monospace",
  },

  darkTheme: {
    bg: "#061828",
    card: "#0d2540",
    border: "#0A2540",
    inputBorder: "#2a2a35",
  },
} as const;
